import React from "react";
import "./EwayBillSteps.scss";
import { Link } from "react-router-dom";
import {
  EWayBillLogin,
  EWayBillGps,
  EWayBillRegistationGps,
  EWayBillUserPasswaord,
} from "../../assets/images";

type AppProps = {
  history: any;
};

const EwayBillSteps = ({ history }: AppProps) => {
  return (
    <>
      <div
        className="ewayBill-step-container"
        style={{ margin: 0, maxWidth: "100%" }}
      >
        <h1>Steps for E-Waybill API Access</h1>

        <div>
          <h2 className="ewayBill-step-title">
            Step 1 - Log in to your Account on{" "}
            <a
              href="https://www.ewaybillgst.gov.in//Login.aspx"
              target="_blank"
              rel="noopener noreferrer"
              className="ewayBill-link"
            >
              E-Waybill website
            </a>
          </h2>

          <img
            src={EWayBillLogin}
            alt="E-waybill login page"
            className="step-image"
          />
        </div>

        <div className="mt-4">
          <h2 className="ewayBill-step-title mt-2">
            Step 2: Navigate to API registration for GSP. On clicking
            <strong> For GSP</strong> you will be receiving an OTP, which needs
            to be entered to proceed further.
          </h2>

          <img src={EWayBillGps} alt="Eway Portal" className="step-image" />
        </div>

        <div className="mt-4">
          <h2 className="ewayBill-step-title mt-3">
            Step 3: Once you enter the OTP, you can click on{" "}
            <strong>Add/New GSP</strong> and select the GST Provider. In this
            case, add <strong> Quicko Infosoft Pvt. Ltd.</strong>
          </h2>

          <img
            src={EWayBillRegistationGps}
            alt="Eway-bill Dashboard"
            className="step-image"
          />
        </div>

        <div className="mt-4">
          <h2 className="ewayBill-step-title mt-3">
            Step 4: Enter the username and password and then click on{" "}
            <strong>Add</strong>.
          </h2>

          <img
            src={EWayBillUserPasswaord}
            alt="Enable API Access (Image 1.2)"
            className="step-image"
          />
        </div>

        <div className="mt-4">
          <h2 className="ewayBill-step-title mt-3">
            Step 5: After clicking Add, you will be able to see the list of GSP
            registered. Use this Username and password in the E-way bill
            Authentication APIs.
          </h2>
        </div>
      </div>
    </>
  );
};

export default EwayBillSteps;
